/**
 * グルーピング選択 入力用VOクラス
 *
 * @export KYMW0F00OutputModel
 * @class KYMW0F00OutputModel
 */
export class KYMW0F00OutputModel {

  /** グルーピングコード */
  public groupingCode: string = <string>'';

}




